import React from 'react';
import PropTypes from 'prop-types';
import Spacing from '@marvelapp/marvel-ui/spacing';

export default function pre({ children }) {
  return (
    <Spacing type="padding" position="bottom" size="m">
      <pre className="bg-snow padding-m borderRadius-m borderWidth-1 borderStyle-solid borderColor-smoke overflow-auto">
        {children}
      </pre>
    </Spacing>
  );
}

pre.propTypes = {
  children: PropTypes.node.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/markdown/pre.js